<template>
    <v-container fluid>
      <section class="content-header">
        <v-toolbar dark dense color="#96298A">
          <v-toolbar-title>Compras Linea</v-toolbar-title>
          <v-divider class="mx-4" vertical />
          <v-text-field
            v-model="searcher"
            label="Buscar"
            single-line
            hide-details
            clearable
            max-width="200px"
            @keyup.enter="fillCompras()"
            @input="handleChangeSearch()"
          ></v-text-field>
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                ref="getData"
                icon
                @click="fillCompras()"
                x-large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-file-find </v-icon>
              </v-btn>
            </template>
            <span>Buscar</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-divider class="mx-4" vertical />
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="fillCompras()"
                  x-large
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-table-refresh</v-icon>
                </v-btn>
              </template>
              <span>Actualizar Tabla</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
      </section>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="compras"
            :search="searcher"
            class="elevation-1"
            :options.sync="options"
            :server-items-length="totalData"
          >
            <template v-slot:item.acciones="{ item }">
              <v-menu offset-y>
                  <template #activator="{ on: onMenu }">
                    <v-tooltip bottom color="#96298A">
                      <template #activator="{ on: onTooltip }">
                        <v-btn
                          v-on="{ ...onMenu, ...onTooltip }"
                          icon
                          color="#96298A"
                        >
                          <v-icon>mdi-format-list-bulleted-type</v-icon>
                        </v-btn>
                      </template>
                      <span>Opciones</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                      link
                      dense
                      @click="showModalVerGuia(item)"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-eye</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Ver Guía</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="showModalInfoAdicional(item)"
                      v-if="isCliente == 0"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-file-plus</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Agregar Información Adicional</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="showModalEstatus(item)"
                      v-if="isCliente == 0"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-refresh</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Actualizar Estatus</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="showModalEnvTramaco(item)"
                      v-if="isCliente == 0 && item.id_agente == null"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-truck-delivery</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Enviar Tramaco</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="imprimirGuiaTramaco(item)"
                      v-if="isCliente == 0 && item.id_agente == 4"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-file-download</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Imprimir Guía Tramaco</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="showModalEnvServiE(item)"
                      v-if="isCliente == 0 && item.id_agente == null"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-truck-delivery</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Enviar ServiEntrega</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="imprimirGuiaServiE(item)"
                      v-if="isCliente == 0 && item.id_agente == 11"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-file-download</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Imprimir Guía ServiEntrega</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="generarRotulosServiE(item)"
                      v-if="isCliente == 0 && item.id_agente == 11"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-file-download</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Generar Rotulos ServiEntrega</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="generarStickersServiE(item)"
                      v-if="isCliente == 0 && item.id_agente == 11"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-file-download</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Generar Stickers ServiEntrega</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      link
                      dense
                      @click="eliminarGuiaServiE(item)"
                      v-if="isCliente == 0 && item.id_agente == 11"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-delete-forever</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Eliminar Guia ServiEntrega</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
            </template>
            <template v-slot:item.estatus="{ item }">
              {{
                item.estatuslist.length > 0
                  ?
                    item.estatuslist[item.estatuslist.length - 1].estatus != null ? item.estatuslist[item.estatuslist.length - 1].estatus.descripcion : null
                  : null
              }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-dialog  :scrollable="true" v-model="dlgInfoAdicional" width="900" transition="dialog-bottom-transition" persistent :fullscreen="fullScreen">
        <v-card>
          <v-toolbar dark dense color="#96298A">
            <v-toolbar-title>Guía : {{ guia }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-divider vertical />
            <v-btn v-if="!fullScreen" icon dark @click="fullScreen = true">
              <v-icon>mdi-window-maximize</v-icon>
            </v-btn>
            <v-btn v-if="fullScreen" icon dark @click="fullScreen = false">
              <v-icon>mdi-window-minimize</v-icon>
            </v-btn>
            <v-divider vertical />
            <v-btn icon dark @click="closeAndResetCbx()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-0">
            <InfoAdicionalCL :id="idCompraLinea" v-if="idCompraLinea > 0 && dlgMode == 'info'"></InfoAdicionalCL>
            <VerCL :id="idCompraLinea" v-if="idCompraLinea > 0 && dlgMode == 'ver'"></VerCL>
            <EstatusCL :id="idCompraLinea" v-if="idCompraLinea > 0 && dlgMode == 'estatus'"></EstatusCL>
            <EnviarTramaco :id="idCompraLinea" :guias="guiasTransmitir" v-if="idCompraLinea > 0 && dlgMode == 'envtramaco'"></EnviarTramaco>
            <EnviarServiEntrega :id="idCompraLinea" :guias="guiasTransmitir" v-if="idCompraLinea > 0 && dlgMode == 'envservie'"></EnviarServiEntrega>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  <script>
  import apicon from "../plugins/apicon";
  import InfoAdicionalCL from "../components/InfoAdicionalCL.vue";
  import EstatusCL from "../components/EstatusCL.vue";
  import VerCL from "../components/VerCL.vue";
  import EnviarTramaco from "../components/EnviarTramaco.vue";
  import EnviarServiEntrega from "../components/EnviarServiEntrega.vue";

  import apiServiEntrega from "../plugins/apiServiEntrega";
import utils from "../utils/utils";
  export default {
    created: function () {},
    components:{
    InfoAdicionalCL,
    VerCL,
    EstatusCL,
    EnviarTramaco,
    EnviarServiEntrega
},
    data() {
      return {
        dlgMode: null,
        guia : null,
        idCompraLinea: 0,
        guiasTransmitir: [],
        fullScreen: false,
        dlgInfoAdicional: false,
        searcher: "",
        options: {},
        totalData: 0,
        isCliente: 1,
        compras: [],
        headers: [
          { text: "Cliente", value: "cliente" },
          { text: "Guia Master", value: "guia_master" },
          { text: "Guia Hija", value: "guia_hija" },
          { text: "Vuelo", value: "no_vuelo" },
          { text: "Destinatario", value: "destinatario" },
          { text: "Ciudad", value: "ciudad" },
          { text: "Pais Origen", value: "pais_origen" },
          { text: "Ciudad Origen", value: "ciudad_origen" },
          { text: "Estatus", value: "estatus" },
          { text: "Fecha Liberación", value: "fecha_liberacion" },
          { text: "Fecha Entregado", value: "pod_fecha" },
          { text: "Recibido Por", value: "pod_nombre" },
          { text: "Agente", value: "agente.nombre" },
          { text: "Guia Agente", value: "guia_agente" },
          { text: "Acciones", align: "end", value: "acciones", sortable: false },
        ],
        /*Variables*/
        /*Variables*/
      };
    },
    watch: {
      options: {
        handler() {
          this.fillCompras();
        },
        deep: true,
      },
    },
    methods: {
      showModalInfoAdicional: function(item){
        this.fullScreen = false;
        this.idCompraLinea = item.id;
        this.guia = item.guia_hija;
        this.dlgMode = 'info';
        this.dlgInfoAdicional = true;
      },
      showModalEstatus: function(item){
        this.fullScreen = false;
        this.idCompraLinea = item.id;
        this.guia = item.guia_hija
        this.dlgMode = 'estatus';
        this.dlgInfoAdicional = true;
      },
      showModalEnvTramaco: function(item){
        this.fullScreen = false;
        this.idCompraLinea = item.id;
        this.guia = item.guia_hija
        this.guiasTransmitir.push({
          id_guia : item.id
        })
        this.dlgMode = 'envtramaco';
        this.dlgInfoAdicional = true;
      },
      showModalEnvServiE: function(item){
        this.fullScreen = false;
        this.idCompraLinea = item.id;
        this.guia = item.guia_hija;
        this.guiasTransmitir.push({
          id_guia : item.id
        })
        this.dlgMode = 'envservie';
        this.dlgInfoAdicional = true;
      },
      closeAndResetCbx: function(){
        this.idCompraLinea = 0;
        this.guia = null;
        this.guiasTransmitir = [];
        this.dlgInfoAdicional = false;
        if(this.dlgMode != 'ver'){
          this.fillCompras();
        }
        this.dlgMode = null;
      },
      showModalVerGuia: function(item){
        this.fullScreen = false;
        this.idCompraLinea = item.id;
        this.guia = item.guia_hija;
        this.dlgMode = 'ver';
        this.dlgInfoAdicional = true;
      },
      //Obtener los datos para rellenar la tabla del index
      fillCompras: function () {
        const { page, itemsPerPage } = this.options;
        apicon
          .getDataApi(
            apicon.getApiBaseUrl() +
              "compraslinea?page=" +
              page +
              "&per_page=" +
              itemsPerPage +
              (this.searcher != null ? "&search=" + this.searcher : "")
          )
          .then((result) => {
            this.compras = result.data;
            this.totalData = result.total;
          });
      },
      imprimirGuiaTramaco: function(item){
        apicon.downloadDataApi(apicon.getApiBaseUrl() + 'imprimirpdftramaco/' + item.guia_agente).then((result) => {
          utils.forceFileDownload(result,'.pdf',true,"Tramaco_Guia_" + item.guia_hija,"application/pdf")
        })
      },
      imprimirGuiaServiE: function(item){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'imprimirguiaservie/' + item.guia_agente).then((result) => {
          if(result.archivoEncriptado){
            const bytesData = utils.convertBase64toBytes(result.archivoEncriptado);
            utils.forceFileDownload(bytesData,'.pdf',true,"ServiEntrega_Guia_" + item.guia_hija,"application/pdf")
          }
        });
        //apiServiEntrega.imprimirGuia(item.guia_agente);
        //apiServiEntrega.imprimirGuia(21177);
      },
      generarRotulosServiE: function(item){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'imprimirrotulosservie/' +item.guia_agente).then((result) => {
          const bytesData = utils.convertBase64toBytes(result.archivoEncriptado);
          utils.forceFileDownload(bytesData,'.pdf',true,"ServiEntrega_Rotulos_" + item.guia_hija,"application/pdf")
        })
        //apiServiEntrega.generarRotulos(item.guia_agente);
      },
      generarStickersServiE: function(item){
        apiServiEntrega.generarStickers(item.guia_agente);
      },
      eliminarGuiaServiE: function(item){
        apicon.deleteDataApi(apicon.getApiBaseUrl() + 'eliminarservie/' + item.id).then((result) =>{

        })
      },
      handleChangeSearch: function () {
        if (this.searcher == null || this.searcher == "") {
          this.fillCompras();
        }
      },
    },
    mounted() {
      apicon.setAuthHeaders();
      this.isCliente = localStorage.getItem("cliente");
    },
  };
  </script>
  <style scoped>
  .v-data-table.v-data-table.v-data-table >>> td {
    font-size: 0.7rem !important;
    padding: 4px;
  }
  .v-data-table.v-data-table.v-data-table >>> th {
    font-size: 0.8rem !important;
    padding: 4px;
  }
  </style>
